import { searchInJSONArray, removeFromJSONArray, getMaxFromJSONArray } from '../../helpers/helpers';
import { useEffect, useState } from 'react';
import { ChartWindow } from './chartwindow';

export const ChartWindows = ( {station, actual, openedStation, onCloseChartWindow} ) => {

    const [ stations, setStations ] = useState([]);

    //обновление слоя актуальности передаем в открытые chartwindow
    useEffect(() => {
        if (actual && stations.length) {
            setStations(prev => prev.map(item => {
                if (!item?.station?.uuid) return item;
                const freshStation = actual.find(curr => curr.uuid === item.station.uuid);
                if (!freshStation) return item;

                return {
                    ...item,
                    station: {                        
                        ...item.station,
                        ...freshStation,
                    },
                    mchs: freshStation.mchs || item.mchs,
                };
            }));
        }
    }, [actual]);

    useEffect(() => {
        if (station) {   
            prepare();
        }
    }, [station]);

    function prepare() {
        let currStations = stations;
//        if (!searchInJSONArray(stations, 'index', station.station.index)) {
            currStations.push({
                uuid: station.station.uuid,
                station: station.station,
                mchs: station.mchs,
                index: getMaxFromJSONArray( stations, 'index') + 1,
                is_top: 1,
                tab: station.tab,
                start: station.start,
                finish: station.finish
            })
//        }
        setStations([...currStations]);            
    };

    function remove(index) {
        return removeFromJSONArray( stations, 'index', index);
    };

    const onClose = ( uuid ) => {
        let newStations = remove( uuid );
        onCloseChartWindow();
        setStations([...newStations]);
    };

    return (
        <div id="charts-window">
            {stations.map( station => (
                <ChartWindow key={`chart_window_${station.index}`} station={station} onClose={onClose} mchs={station.mchs}/>
            ))}
        </div>

    );
}
